const imageOnly = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/svg+xml', 'image/gif', 'image/heic'];

const pdfOnly = ['application/pdf'];

const allOthers = [
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-powerpoint', // .ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'application/postscript', // .ai
  'image/vnd.adobe.photoshop', // .psd
  'text/plain', // .txt
  'application/json', // .json
  'application/xml', // .xml
  'text/csv', // .csv
];

export const allowedFileTypes = {
  imageOnly,
  pdfOnly,
  allOthers,
  filesOnly: [...pdfOnly, ...allOthers],
  all: [...imageOnly, ...pdfOnly, ...allOthers],
};
